import React, { useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import changeImage from '../../assets/changeImage.png';
import editProf from '../../assets/editProf.png';
import profile from '../../assets/ic _poli_homepage.png';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ImageUploader from 'react-images-upload';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddPoli(props) {
    const [speciality, setListSpeciality] = useState([])
    const [deskripsi, setDeskripsi] = useState(null)
    const [referalCode, setReferalCode] = useState(null)
    const [kode, setKode] = useState("")
    const [photo, setPhoto] = useState("")
    const [photo2, setPhoto2] = useState("")
    const [uploadVisible, setUploadVisible] = useState(false)
    const [pictures, setPicture] = useState([])
    const [pictures2, setPicture2] = useState([])
    const [namaPicture2, setNamaPicture2] = useState([])
    const [image, setImage] = useState([profile])
    const [name, setName] = React.useState(null)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [visibleImage, setVisibleImage] = React.useState(false);
    const [errorName, setErrorName] = React.useState(false);
    const [errorDeskripsi, setErrorDeskripsi] = React.useState(false);
    const [errorKode, setErrorKode] = React.useState(false);
    const [texterrorName, setTextErrorName] = React.useState(null);
    const [textErrorDeskripsi, setTextErrorDeskripsi] = React.useState(null);
    const [textErrorKode, setTextErrorKode] = React.useState(null);
    const listEksekutif = [
        { value: "Tidak", id: 0 },
        { value: "Ya", id: 1 },
    ]
    const [isEksekutif, setIsEksekutif] = React.useState(listEksekutif[0]);

    React.useEffect(() => {
        getDataSpesialis()
    }, [])

    const forceUpdate = React.useReducer(bool => !bool)[1];


    const handleOnChange = (e) => {
        setName(e.target.value)
        setErrorName(false)
        setTextErrorName(null)
        forceUpdate()
    }

    const getDataSpesialis = (value) => {
        if (value === undefined || value === "") {
            api.create().getListSpesialisDokter(value === undefined ? "" : value).then(response => {
                console.log(response)
                if (response.data) {
                    let listPoli = []
                    response.data.data.map((item, index) => {
                        listPoli.push({
                            id: item.id,
                            name: String(item.name).trim()
                        })
                    })
                    setListSpeciality(listPoli)
                }
            })
        }
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const doSubmit = (e) => {
        let id;
        let photo = pictures[0]
        let photo2 = pictures2[0]
        console.log(photo);
        if (!name) {
            setErrorName(true)
            setTextErrorName("nama klinik wajib diisi")
        } else if (kode === "") {
            setErrorKode(true)
            setTextErrorKode("kode wajib diisi")
        } else if (!deskripsi) {
            setErrorDeskripsi(true)
            setTextErrorDeskripsi("deskripsi wajib diisi")
        }
        else {
            let formData = new FormData()
            formData.append('name', name)
            formData.append('desc', deskripsi)
            formData.append('code', kode)
            formData.append('bpjs_reference_code', referalCode)
            formData.append('is_executive', isEksekutif.id)
            if (photo !== undefined) {
                formData.append('photo', photo)
            }
            if (photo2 !== undefined) {
                formData.append('photo2', photo2)
            }
            console.log(...formData);
            api.create().createPoli(formData).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.data.photo === "photo harus berupa sebuah berkas.") {
                        alert('Foto tidak boleh kosong')
                    } else {
                        if (response.data.status === true) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.message)
                            setStatusAlert("Succes")
                            props.onClose()
                            props.getData()
                        } else {
                            if (response.data.data) {
                                if (response.data.data.photo2) {
                                    setOpenAlert(true)
                                    setMessageAlert(response.data.data.photo2)
                                    setStatusAlert("warning")
                                } else if (response.data.data.code) {
                                    setOpenAlert(true)
                                    setMessageAlert(response.data.data.code)
                                    setStatusAlert("warning")
                                } else {
                                    setOpenAlert(true)
                                    setMessageAlert(response.data.data)
                                    setStatusAlert("warning")
                                }
                            } else {
                                alert(response.data.message)
                            }
                        }
                    }
                }
            })
        }
    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs, '----------------1');
        console.log(pictureFiles);
        setPhoto(pictureDataURLs)
        setPicture(pictureFiles)
        // console.log(response);
        // console.log(pictureDataURLs);
        // this.setState({
        //     pictures: this.state.pictures.concat(pictureFiles),
        // });
    }

    const onDrop2 = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs);
        setPhoto2(pictureDataURLs)
        setPicture2(pictureFiles)
        setNamaPicture2(pictureFiles[0].name)
    }

    const uploadFoto = () => {
        // console.log(pictures[0].name, '================2');
        // api.create().uploadFoto(pictures[0].name).then(response => {
        //     console.log(response);
        // })
        setUploadVisible(false)
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Klinik Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div style={{ margin: 'auto', width: 134, height: 134, backgroundColor: photo === "" ? 'green' : 'transparent', marginTop: 20, borderRadius: 80 }}>
                    <img src={photo === "" ? image : photo} style={{ width: 126, height: 126, marginTop: 3, borderRadius: 60 }} />
                    <div style={{ marginTop: -19, marginLeft: 7 }}>
                        <img src={changeImage} style={{ width: 102, height: 24, marginRight: 8 }} />
                        <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer' }}
                            onClick={(e) => {
                                setPicture("")
                                setUploadVisible(true)
                            }}
                        />
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="namaPoli"
                                name="namaPoli"
                                required={true}
                                error={errorName}
                                helperText={texterrorName}
                                label="Nama Klinik"
                                placeholder={"input nama klinik"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                label="Detail Image"
                                placeholder={"Pilih Image"}
                                onClick={() => {
                                    setVisibleImage(true)
                                    setPicture2("")
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={namaPicture2}
                            />
                        </div>
                        <Autocomplete
                            options={listEksekutif}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setIsEksekutif(newInputValue)
                            }}
                            style={{ marginTop: 24 }}
                            value={isEksekutif}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Eksekutif"
                                />
                            }
                        />
                    </div>
                    <div className="column-2">
                        <div style={{ marginTop: 15 }}>
                            <TextField
                                style={{ width: '100%' }}
                                required={true}
                                error={errorKode}
                                helperText={textErrorKode}
                                label="Kode Poliklinik"
                                placeholder={"input Kode Poliklinik"}
                                onChange={(e) => {
                                    setKode(e.target.value)
                                    setErrorKode(false)
                                    setTextErrorKode(null)
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <TextField
                                style={{ width: '100%' }}
                                id="deskripsi"
                                required={true}
                                name="deksripsi"
                                error={errorDeskripsi}
                                helperText={textErrorDeskripsi}
                                multiline
                                rowsMax={10}
                                label="Deskripsi"
                                placeholder={"input deskripsi"}
                                onChange={(e) => {
                                    setDeskripsi(e.target.value)
                                    setErrorDeskripsi(false)
                                    setTextErrorDeskripsi(null)
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <TextField
                                style={{ width: '100%' }}
                                id="Kode Referensi BPJS"
                                name="referalCode"
                                multiline
                                rowsMax={10}
                                label="Kode Referensi BPJS"
                                placeholder={"input kode referensi BPJS"}
                                onChange={(e) => {
                                    setReferalCode(e.target.value)
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit(e)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
                {uploadVisible && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setUploadVisible(false)
                                            setPicture("")
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            <ImageUploader
                                withIcon={true}
                                withPreview
                                buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                                buttonText={'Select Picture'}
                                onChange={onDrop}
                                imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                maxFileSize={1000000}
                                label={"Max file size: 1 Mb, accepted: jpg or png"}
                            />
                            {pictures.length > 0 ?
                                <div style={{ display: 'grid', margin: 20 }}>
                                    <div style={{ justifySelf: 'center' }}>
                                        <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto()}>Upload</span>
                                    </div>
                                </div> : null
                            }
                        </div>
                    </div>
                )}


                {visibleImage && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setVisibleImage(false)
                                            setPicture2("")
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            <ImageUploader
                                withIcon={true}
                                withPreview
                                buttonStyles={pictures2.length > 0 ? { display: 'none' } : null}
                                buttonText={'Select Picture'}
                                onChange={onDrop2}
                                imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                                maxFileSize={1000000}
                                label={"Max file size: 1 Mb, accepted: jpg or png"}
                            />
                            {pictures2.length > 0 ?
                                <div style={{ display: 'grid', margin: 20 }}>
                                    <div style={{ justifySelf: 'center' }}>
                                        <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => setVisibleImage(false)}>Upload</span>
                                    </div>
                                </div> : null
                            }
                        </div>
                    </div>
                )}


            </div>
        </div>
    )
}